/* Product-page callback events (all greenhouse heroes). Loaded by every greenhouse hero section; the guard keeps it to
   one copy per page. Pushes to window.igEvents (Intelligems custom events) and window.dataLayer (GTM):
     pdp_callback_click     the 'Need help? Ask an expert' card button ([data-callback-card])
     pdp_callback_submit    an accepted HubSpot submission of a hero callback form ([data-callback-modal][id^=np-cb-])
     pdp_delivery_see_more  'See more' in the delivery line under the buy button
   Intelligems test 'PDP callback look': round 1 (2026-10-30, ended 10-31) A = the old avatar card (html.ygh-cb-old) vs
   B = the dark green button; round 2 (from 2026-10-31) B = the dark green button (control) vs C = the April/May card in
   the new styling (html.ygh-cb-sage); from 2026-11-01 B's button reads 'Need help? Talk to an expert' (was 'Have a
   greenhouse expert call me'; the label below says which wording a lead saw). Intelligems injects window.yghCbLook = the letter (the classes are read by
   new-pdp-nord-hero.css), so HubSpot notes from both rounds say which button the lead saw. A hero callback
   submitted inside the test is reported to the lead relay (/abtag), which adds a timeline note to the HubSpot lead and
   contact. The ?ygh-cb=old preview sets no version, so previews are never tagged.
   History: this file ran the Intelligems test 'PDP callback position' (629d90c5, 2026-09-30 to 2026-10-22). Version B,
   card ABOVE the trust row, won and is now the default layout in each hero's CSS. File name kept so the five hero
   sections that load it did not need changing. */
(function () { if (window.__yghCbPosTest) return; window.__yghCbPosTest = true;
  var RELAY = 'https://ygh-lead-relay.raitislm.workers.dev/abtag';
  var LOOK_TEST = 'pdp_callback_look';
  var LOOK_LABELS = { A: 'old avatar card, Request a Callback', B: 'dark green button, Need help? Talk to an expert', C: 'April/May card, Have a greenhouse expert call me' };
  function look() { var v = String(window.yghCbLook || '').toUpperCase(); return LOOK_LABELS[v] ? v : null; }
  function track(name) {
    try { window.igEvents = window.igEvents || []; window.igEvents.push({ event: name }); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, ygh_cb_look: look() || '' }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-callback-card]')) track('pdp_callback_click');
    if (e.target && e.target.closest && e.target.closest('[data-npwmp-cta-note] .ship-more')) track('pdp_delivery_see_more');
  });
  function heroForm(id) {
    var hit = false;
    document.querySelectorAll('[data-callback-modal][id^="np-cb-"]').forEach(function (mo) { if (mo.getAttribute('data-callback-hs-form') === id) hit = true; });
    return hit;
  }
  /* the lead's email: the theme's own form puts the values in the event (detail.values), the HubSpot embed hands them out through its API */
  function emailFrom(list) {
    var email = '';
    (list || []).forEach(function (f) { var n = f && f.name ? String(f.name) : ''; if (n === 'email' || n.slice(-6) === '/email') email = Array.isArray(f.value) ? f.value[0] : f.value; });
    return String(email || '').trim();
  }
  function phoneFrom(list) {
    var phone = '';
    (list || []).forEach(function (f) { var n = f && f.name ? String(f.name) : ''; if (n === 'phone' || n.slice(-6) === '/phone') phone = Array.isArray(f.value) ? f.value[0] : f.value; });
    return String(phone || '').trim();
  }
  function tagLead(e, id) {
    var v = look();
    if (!v) return; /* outside the test (not US, other page) or a preview: nothing to tag */
    /* the callback form asks for a name and a phone only since 2026-10-31: the relay finds the contact by phone then */
    function send(list) {
      var email = emailFrom(list), phone = phoneFrom(list);
      if (!email && phone.replace(/\D/g, '').length < 10) return;
      var body = JSON.stringify({ email: email, phone: phone, test: LOOK_TEST, variant: v, label: LOOK_LABELS[v], form_id: id, page: location.pathname });
      try { fetch(RELAY, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {}); } catch (x) {}
    }
    var d = e.detail || {};
    if (Array.isArray(d.values)) return send(d.values);
    var api = window.HubSpotFormsV4, form = null;
    try { form = api && api.getFormFromEvent ? api.getFormFromEvent(e) : null; } catch (x) {}
    if (!form || !form.getFormFieldValues) return;
    Promise.resolve(form.getFormFieldValues()).then(function (vals) { send(vals); }, function () {});
  }
  document.addEventListener('hs-form-event:on-submission:success', function (e) {
    var id = (e.detail && e.detail.formId) || '';
    if (!id || !heroForm(id)) return;
    track('pdp_callback_submit');
    tagLead(e, id);
  });
})();
